import { FieldGovernance } from './field-governace'

export const EditTemplateField = props => {
  return <FieldGovernance {...props} isTemplateField />
}
